import { AgFinancing, AgFinancingCreditAnalysisStatus, AgFinancingPhase2Status, Phase2 } from '@indigo-ag/schema';

export class CreditUtil {
  static hasBeenApproved(status?: AgFinancingCreditAnalysisStatus): boolean {
    return status === AgFinancingCreditAnalysisStatus.APPROVED;
  }

  static hasBeenDenied(status: AgFinancingCreditAnalysisStatus): boolean {
    return status === AgFinancingCreditAnalysisStatus.DENIED;
  }

  static hasBeenSent(status?: AgFinancingCreditAnalysisStatus): boolean {
    return status === AgFinancingCreditAnalysisStatus.COMPLETED;
  }

  static hasNotBeenSent(status?: AgFinancingCreditAnalysisStatus): boolean {
    return status === AgFinancingCreditAnalysisStatus.STARTED;
  }

  static isOnHold(status?: AgFinancingCreditAnalysisStatus): boolean {
    return status === AgFinancingCreditAnalysisStatus.ON_HOLD;
  }

  static canOnHoldResume(phaseInfo?: Phase2): boolean {
    return (
      !!phaseInfo?.status &&
      phaseInfo.status === AgFinancingPhase2Status.IN_PROGRESS &&
      !!phaseInfo?.credit?.status &&
      phaseInfo?.credit?.status !== AgFinancingCreditAnalysisStatus.COMPLETED
    );
  }

  static hasStarted(credit?: Phase2['credit']): boolean {
    return !!credit?.startedAt;
  }

  static canStart(canStartPhase2: AgFinancing['canStartPhase2'], phaseInfo?: Phase2): boolean {
    return !!canStartPhase2 && !phaseInfo?.credit?.startedAt;
  }

  static canReopen(phaseInfo?: Phase2): boolean {
    return (
      phaseInfo?.credit?.status === AgFinancingCreditAnalysisStatus.COMPLETED &&
      phaseInfo?.status !== AgFinancingPhase2Status.APPROVED &&
      phaseInfo?.status !== AgFinancingPhase2Status.DENIED
    );
  }
}
